var map = {
	"./field.png": 2848,
	"./goal.png": 8867,
	"./goal_2.png": 131,
	"./player.png": 6508,
	"./player_2.png": 1623,
	"./referee.png": 7026,
	"./trophy.png": 5798,
	"./winner.png": 3255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;